import { Category, CategoryFilter } from '@idea2app/ai-work-order-service';

import { TableModel } from './Base';

export class CategoryModel extends TableModel<Category, CategoryFilter> {
    baseURI = 'category';
}

export default new CategoryModel();
